export default __webpack_public_path__ + "static/media/jumbo-shrimp-dish.bb335071.jpg";